import { render, staticRenderFns } from "./animatedLogo.vue?vue&type=template&id=35b238b0&scoped=true&lang=pug"
import script from "./animatedLogo.vue?vue&type=script&lang=ts"
export * from "./animatedLogo.vue?vue&type=script&lang=ts"
import style0 from "./animatedLogo.vue?vue&type=style&index=0&id=35b238b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b238b0",
  null
  
)

export default component.exports